export default __webpack_public_path__ + "static/media/eeziepay.92f8e570.svg";